export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does Yessica Cleaning and Painting LLC serve?",
    a: "We're based in Plymouth, IN and serve roughly a 75-mile radius — including Bremen, Culver, South Bend, Mishawaka, Goshen, La Porte, Valparaiso, Portage, Crown Point, Munster, and Dyer in Indiana, plus Niles, Three Oaks, and Three Rivers in Michigan.",
  },
  {
    q: "Do you do both cleaning and painting?",
    a: "Yes — that's what makes us different. We handle residential and commercial cleaning, interior and exterior painting, cabinet and trim refinishing, and pressure washing. Many customers book a pressure wash and exterior paint together, or a full interior repaint followed by a deep clean.",
  },
  {
    q: "How much does a cleaning or painting job cost?",
    a: "Pricing depends on the size of your space, the type of service, and the condition of the surfaces. Every estimate is free and written out clearly with no hidden fees — just call or send us a message and we'll get back to you quickly.",
  },
  {
    q: "Do you offer discounts for repeat customers?",
    a: "Yes. Returning customers save 25% on their next service, and that discount extends to friends and family you refer to us.",
  },
  {
    q: "What are your hours?",
    a: "We're available Monday through Friday, 7:00 AM to 5:30 PM. Commercial customers who need work done outside those hours can ask — we'll do our best to schedule around your business.",
  },
  {
    q: "Do you provide your own supplies and equipment?",
    a: "Yes. We bring everything — cleaning products, microfiber cloths, mops, vacuums, paint, brushes, sprayers, drop cloths, and our pressure washing equipment. You don't need to supply anything.",
  },
  {
    q: "Can you paint kitchen cabinets instead of replacing them?",
    a: "Absolutely, and it's one of our most requested services. We remove the doors, label the hardware, degrease and sand every surface, apply bonding primer, then finish with a durable enamel. It costs a fraction of new cabinets and usually takes a few days instead of weeks.",
  },
  {
    q: "Do you pressure wash before exterior painting?",
    a: "Always. Paint won't bond to dirt, chalking, or mildew. Pressure washing is included as part of our exterior painting prep, along with scraping, sanding, caulking, and priming.",
  },
  {
    q: "Do you handle move-in, move-out, and rental turnovers?",
    a: "Yes. We do move-in and move-out cleans, post-construction cleanup, and rental turnovers — including quick interior touch-up painting between tenants.",
  },
];
